<template>
  <layout-m-vue>
    <template slot="title">
      <div class="header-content" @click="goSearch">
        <input v-model="keyword" type="text" placeholder="十万种商品 一站式采购" />
        <em class="search"></em>
      </div>
    </template>
    <template slot="content">
      <div class="header-content" @click="goSearch" v-if="isAPP">
        <input v-model="keyword" type="text" placeholder="十万种商品 一站式采购" />
        <em class="search"></em>
      </div>
      <div class="search-page" v-cloak>
        <coupon-list-vue :keyword="keyword" :categoryid="categoryId" ref="coupon" @judgeshow='judgeshow'></coupon-list-vue>
        <recomend-vue :keyword="keyword" :showlength="showlength"></recomend-vue>
        <div class="main-tab">
          <span :class="mainTab == 'goods'? 'active': ''" @click="changeMainTab('goods')">商品</span>
          <span :class="mainTab == 'shops'? 'active': ''" @click="changeMainTab('shops')">店铺</span>
        </div>
        <good-tab-vue v-if="mainTab == 'goods'"></good-tab-vue>
        <shop-tab-vue v-if="mainTab == 'shops'"></shop-tab-vue>
      </div>
    </template>
  </layout-m-vue>

</template>
<script>
import layoutMVue from '../../components/layout/layoutM.vue'
import couponListVue from './components/couponList.vue'
import recomendVue from './components/recomend.vue'
import goodTabVue from './components/goodTab.vue'
import shopTabVue from './components/shopTab.vue'
import { listProductCategory, listProductBrand } from '../../request/search'
export default {
  components: { layoutMVue, couponListVue, recomendVue, goodTabVue, shopTabVue },
  data() {
    return {
      showlength: true,
      mainTab: 'goods',
      isAPP: $HMD$.rNavigator == 'ios' || $HMD$.rNavigator == 'android',
    }
  },
  created() {
    // this.setPageTitle()
  },
  computed: {
    brandId() {
      return !isNaN($HMD$.rParam('b')) ? $HMD$.rParam('b') : '' //品牌
    },
    categoryId() {
      return $HMD$.rParam('c') || '' //分类
    },
    categoryLevel() {
      return $HMD$.rParam('level') || '' //分类级别
    },
    keyword() {
      return $HMD$.rParam('k') || '' //关键字
    },
    shopIsFilter() {
      return Number(this.shopData.categoryKey) || (this.shopData.shopTypeKey != 'ALL' && this.shopData.shopTypeKey != '') ? true : false
    },
  },
  mounted() {
    if ($HMD$.rNavigator == 'ios' || $HMD$.rNavigator == 'android') {
      $HMD$.M.Ready(function () {
        $HMD$.M.sendApp({ name: 'showShare', key: false })
      })
    }
  },
  methods: {
    setPageTitle() {
      if ($HMD$.rParam('k')) {
        let name = $HMD$.rParam('k')
        document.title = $HMD$.rParam('k') + '采购批发-' + $HMD$.rParam('k') + '报价-' + $HMD$.rParam('k') + '供应-河姆渡智能建筑产业互联网平台'
        document.querySelector("meta[name='keywords']").setAttribute('content', `${name}采购平台,${name}报价,${name}批发网,${name}供应-${name}解决方案`)
        document.querySelector("meta[name='description']").setAttribute('content', `河姆渡提供${name}报价,采购,批发和供应一站式综合服务,专注于智能建筑、智慧城市、智能家居的产业互联网平台,为弱电安防、IT信息化设施等系统集成商和工程商提供专业解决方案`)
      } else if ($HMD$.rParam('c')) {
        listProductCategory({ ids: $HMD$.rParam('c').split(',') }).then((res) => {
          if (res.status == '200' && res.data.respCode == '0000') {
            let name = (res.data.data && res.data.data.list[0] && res.data.data.list[0].name) || ''
            document.title = name + '采购批发-' + name + '报价-' + name + '供应-河姆渡智能建筑产业互联网平台'
            document.querySelector("meta[name='keywords']").setAttribute('content', `${name}采购平台,${name}报价,${name}批发网,${name}供应-${name}解决方案`)
            document.querySelector("meta[name='description']").setAttribute('content', `河姆渡提供${name}报价,采购,批发和供应一站式综合服务,专注于智能建筑、智慧城市、智能家居的产业互联网平台,为弱电安防、IT信息化设施等系统集成商和工程商提供专业解决方案`)
          }
        })
      } else if ($HMD$.rParam('b')) {
        listProductBrand($HMD$.rParam('b')).then((res) => {
          if (res.status == '200' && res.data.respCode == '0000') {
            let name = (res.data.data[0] && res.data.data[0].name) || ''
            document.title = name + '采购批发-' + name + '报价-' + name + '供应-河姆渡智能建筑产业互联网平台'
            document.querySelector("meta[name='keywords']").setAttribute('content', `${name}采购平台,${name}报价,${name}批发网,${name}供应-${name}解决方案`)
            document.querySelector("meta[name='description']").setAttribute('content', `河姆渡提供${name}报价,采购,批发和供应一站式综合服务,专注于智能建筑、智慧城市、智能家居的产业互联网平台,为弱电安防、IT信息化设施等系统集成商和工程商提供专业解决方案`)
          }
        })
      }
    },
    goSearch() {
      if (this.isAPP) {
        $HMD$.M.sendApp({ name: 'tob2bsearch', title: '' })
      } else {
        location.href = `${$HMD$.rApi.M}/home/searchPage`
      }
    },
    judgeshow(data) {
      // return data.length
      this.showlength = data.length
    },
    //商品，店铺切换
    changeMainTab(tab) {
      this.mainTab = tab
      this.showPopId = ''

      $HMD$.aYiGuan('btn_click', null, {
          $url: window.location.href,
          $title: document.title,
          btn_name: tab == 'goods'?'商品':'店铺',
          platform:$HMD$.rNavigator
        })

      if (tab == 'goods') {
        //页面停留时长埋点
        let endTime = new Date().getTime()
        $HMD$.aYiGuan('page_close', null, {
          $url: window.location.href,
          $url_domain: window.location.origin + window.location.pathname,
          $title: document.title,
          pagestaytime: (endTime - this.viewShopStart) / 1000,
        })

      } else {
        this.viewShopStart = new Date().getTime()
        $HMD$.aYiGuan('$pageview', null, {
          content_type: '搜索列表页',
          $url: window.location.href,
          $url_domain: window.location.origin + window.location.pathname,
          $title: document.title,
          $referrer: document.referrer,
          $referrer_domain: '',
          $traffic_source_type: '',
          $search_engine: '',
          $search_keyword: this.keyword,
          $social_media: '',
          $social_share_from: '',
          source_module: '',
        })
      }
    },
    gift(){
      console.log("ppp",)
    }
  },
}
</script>
<style  scoped lang="less">
@import '../../assets/style/theme.less';
.header-content {
  height: 2.5rem;
  overflow: hidden;
  padding: 0 0.5rem;
  display: block;
  position: relative;
  input {
    width: 100%;
    height: 2.5rem;
    line-height: 2.5rem;
    outline: none;
    border: none;
    background: #f6f7f9;
    border-radius: 0.5rem;
    box-sizing: border-box;
    padding: 0 0 0 2.5rem;
  }
  .search {
    display: block;
    position: absolute;
    height: 1.8rem;
    width: 1.8rem;
    left: 1.2rem;
    top: 0.5rem;
    background: url(//image10.homedo.com/Mobile/search-icon.png) 0 0 no-repeat;
    background-size: 1.4rem;
  }
}
.main-tab {
  padding: 1rem;
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  font-size: 1.6rem;
  font-weight: bold;
  .active {
    color: @hmd-primary-color;
  }
}

</style>
